import React from "react";
import "./skeleton.css";

const SkeletonCard = () => (
  <div className="skeleton-box">
    <div className="skeleton-shimmer" />
    <div className="skeleton-line skeleton-image" />
    <div className="skeleton-line skeleton-title" />
    <div className="skeleton-line skeleton-text" />
    <div className="skeleton-line skeleton-text" style={{ width: "70%" }} />
  </div>
);

const SkeletonLoader = ({ type = "grid", count = 3 }) => {
  if (type === "grid" || type === "portfolio") {
    return (
      <div className="container skeleton-grid">
        {Array.from({ length: count }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="container skeleton-wrapper">
      <div className="skeleton-box" style={{ height: "200px" }}>
        <div className="skeleton-shimmer" />
        <div className="skeleton-line skeleton-title" style={{ width: "40%" }} />
        <div className="skeleton-line skeleton-text" />
        <div className="skeleton-line skeleton-text" style={{ width: "80%" }} />
      </div>
    </div>
  );
};

export default SkeletonLoader;
